import {
  createIcon as chakraCreateIcon,
  type IconProps
} from "@chakra-ui/react";
import { type ReactElement } from "react";

export interface CreateIconOptions {
  displayName?: string;
  viewBox?: string;
  path?: ReactElement;
  d?: string;
}

export function createIcon(options: CreateIconOptions) {
  const { displayName, viewBox = "0 0 24 24", path, d } = options;

  return chakraCreateIcon({
    displayName: displayName ?? "CustomIcon",
    viewBox,
    path: path ?? (d ? <path fill="currentColor" d={d} /> : undefined)
  });
}

export type { IconProps };
